import React from 'react';

import './page.css';

//
import MainTitle from '../../components/page/main-title/MainTitle';

// import route Components here
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch,
  Redirect
} from 'react-router-dom';

class Campanhas extends React.Component{
  constructor (props){
    super(props);
  }

  render() {
    return (
      <div className="page-campanhas" >
        <div className="container">
          <div className="container-box">
            <div className="container-box--inner">
              <MainTitle title="Campanhas"></MainTitle>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Campanhas;



// WEBPACK FOOTER //
// ./src/classes/campanhas/Campanhas.js